import { render } from "./KSModalFilters.vue?vue&type=template&id=61f06c5e&scoped=true"
import script from "./KSModalFilters.vue?vue&type=script&lang=js"
export * from "./KSModalFilters.vue?vue&type=script&lang=js"

import "./KSModalFilters.vue?vue&type=style&index=0&id=61f06c5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f06c5e"]])

export default __exports__